import '../../_rollupPluginBabelHelpers-a38db067.js';
import { get } from './core-utils.js';

function createStyleFunction({
  properties,
  property,
  transform = get
}) {
  const p = properties || (property ? [property] : []);
  const styleFn = (value, props) => {
    const result = {};
    const transformedValue = transform(undefined, value, value, props);
    if (transformedValue === null) {
      return undefined;
    }
    if (Array.isArray(transformedValue) && properties.length > 1) {
      p.forEach((prop, index) => {
        result[prop] = transformedValue[index];
      });
    } else {
      p.forEach(prop => {
        result[prop] = transformedValue;
      });
    }
    return result;
  };
  styleFn.properties = properties;
  styleFn.property = property;
  styleFn.transform = transform.name !== 'get' ? transform : undefined;
  return styleFn;
}

export { createStyleFunction };
